/**
 * MenuOptions
 */

import CustomerModal from 'components/ui/CustomerModal';
import IconSelect from 'components/ui/IconSelect';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	FetchUser,
	UpdateTypes,
	selectUserData,
	selectUserObject,
	UpdateProjects,
	UpdateWarehouses,
} from 'store/modules/user';

interface Props {
	/** Tooltip for warehouse select */
	warehouseTooltip?: string;
}

/** Main description for this component. */
const MenuOptions = ({ warehouseTooltip }: Props): JSX.Element => {
	const dispatch = useDispatch();
	const { types, customers, projects, warehouses } = useSelector(
		selectUserObject
	);
	const { customerLoading, userObject } = useSelector(selectUserData);
	const [customerSearch, setCustomerSearch] = useState(false);

	const [isSalesUser, setIsSalesUser] = useState(false);

	useEffect(() => {
		userObject.salesUser && setIsSalesUser(true);
	}, [userObject]);

	const selectedCustomer = customers?.filter(
		(item: any) => item.selected === true
	)[0];

	const selectedProject = projects?.filter(
		(item: any) => item.selected === true
	)[0];

	const selectedWarehouse = warehouses?.filter(
		(item: any) => item.selected === true
	)[0];

	const selectedType = types?.filter((item: any) => item.selected === true)[0];

	const handleCustomerChange = async (selectedItem: any) => {
		await dispatch(FetchUser(selectedItem.id));
	};

	const handleTypeChange = async (selectedItem: any) => {
		await dispatch(UpdateTypes(selectedItem.id));
	};

	const handleProjectChange = async (selectedItem: any) => {
		await dispatch(UpdateProjects(selectedItem.id));
	};

	const handleWarehouseChange = async (selectedItem: any) => {
		await dispatch(UpdateWarehouses(selectedItem.id));
	};

	return (
		<div className="lg:flex flex-wrap gap-8 lg:justify-end">
			{customerSearch && (
				<CustomerModal
					onChange={handleCustomerChange}
					onToggle={() => setCustomerSearch(false)}
				/>
			)}
			{types && types.length > 0 && (
				<IconSelect
					id="types"
					order={
						projects &&
						projects.length > 0 &&
						types &&
						types.length > 0 &&
						customers &&
						customers.length &&
						warehouses &&
						warehouses.length > 0
							? '4'
							: ''
					}
					icon="archive"
					iconColor={'#000000'}
					selected={selectedType}
					items={types}
					onChange={handleTypeChange}
					loading={customerLoading}
				/>
			)}
			{customers && customers.length > 0 && (
				<IconSelect
					id="customers"
					icon="user"
					iconColor={'#000000'}
					selected={selectedCustomer}
					items={customers}
					onChange={handleCustomerChange}
					salesUser={isSalesUser}
					handleOpenCustomerSearch={() => setCustomerSearch(!customerSearch)}
				/>
			)}

			{projects && projects.length > 0 && (
				<IconSelect
					id="projects"
					icon="calendarPen"
					iconColor={'#000000'}
					selected={selectedProject}
					items={projects}
					onChange={handleProjectChange}
					loading={customerLoading}
				/>
			)}
			{warehouses && warehouses.length > 0 && (
				<IconSelect
					id="warehouses"
					icon="mapPin"
					iconColor={'#000000'}
					selected={selectedWarehouse}
					items={warehouses}
					onChange={handleWarehouseChange}
					warehouseTooltip={warehouseTooltip}
					loading={customerLoading}
				/>
			)}
		</div>
	);
};

export default MenuOptions;
